import { memo, useCallback, useState } from 'react';
import { Box, Image, Skeleton } from '@bonanza-social/moonlight';
import { BonusImageProps } from './BonusImage.types';

function BonusImage({ name, miniImageUrl, ...rest }: BonusImageProps) {
  const [loaded, setLoaded] = useState(false);
  const existing = name || miniImageUrl;

  const onLoad = useCallback(() => {
    setLoaded(true);
  }, []);

  return (
    <Box {...rest}>
      {existing ? (
        <Image
          name={name && `promos.${name}`}
          source={miniImageUrl}
          onLoad={onLoad}
          contentFit="cover"
          borderWidth="border-width-050"
          borderColor="borderPrimary"
          borderRadius="radius-200"
          width="100%"
          height="100%"
        />
      ) : null}
      {!loaded ? (
        <Skeleton
          borderWidth="border-width-050"
          borderColor="borderPrimary"
          borderRadius="radius-200"
          width="100%"
          height="100%"
        />
      ) : null}
    </Box>
  );
}

export default memo(BonusImage);
